import { InputHTMLAttributes } from "react";

import { CheckBoxWrapper, CheckBoxLabel, CheckBox } from "./styles";

interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
  text: string;
  loading?: boolean;
  startWithMinWidth?: boolean;
  switchWidth?: number;
  switchHeight?: number;
  switchColor?: string;
  switchHoverColor?: string;
}

export function SwitchInput({
  text,
  loading = false,
  switchWidth = undefined,
  switchHeight = undefined,
  switchColor = "var(--fixit)",
  switchHoverColor = "var(--fixit-hover)",
  id = "checkbox",
  ...rest
}: SwitchProps) {
  return (
    <CheckBoxWrapper>
      <CheckBox
        switchHeight={switchHeight}
        switchWidth={switchWidth}
        switchColor={switchColor}
        switchHoverColor={switchHoverColor}
        id={id} type="checkbox"
        {...rest}
      />
      <CheckBoxLabel htmlFor={id}/>
      {loading ? <div className="loading" /> : <>{text}</>}
    </CheckBoxWrapper>
  );
}
